import Svg from '../generated/DesignElementBi3';
import { Icon, type IconProps } from './Icon';

export const DesignElementBi3Icon = (props: IconProps) => (
    <Icon component={Svg} name="designElementBi3" inheritColors={false} {...props} />
);
